import { store } from '@atredux/store'
import { getSelectedLocale } from '@src/redux/selectors/localeSelector'
import { getToolUrl } from '@src/services/ToolMenuConfigService'
import { CrossFrameUtils } from '@amzn/jwo-store-management-platform-components'

const INVENTORY_TOOL_NAME: string = 'Inventory Viewer'
export const IVFrameId = 'IVFrame'
export const ATBaseToolFrameContainerClass = 'iframe-container'
export const SeawardToolFrameContainerClass = 'seaward-iframe-container'

type ToolType = 'seaward' | 'ATBase'
type IVEvent = 'openIVEvent' | 'closeIVEvent'
type IVOrigin = 'modal' | 'sidebar'

export class InventoryViewerModalUtils {
    private static inventoryViewerBaseUrl: string
    private static inventoryViewerParams: string

    public static getUrl () {
        if (!this.inventoryViewerBaseUrl) {
            // If Inventory Viewer ever becomes a truly hidden tool, this will need to be changed
            const url = getToolUrl(INVENTORY_TOOL_NAME)
            this.inventoryViewerBaseUrl = url?.split('?')[0]
            this.inventoryViewerParams = url?.split('?')[1]
        } else {
            const localeParam = store?.getState().locale ? getSelectedLocale(store.getState()) : 'en-US'
            const queryParams = new URLSearchParams(this.inventoryViewerParams)
            queryParams.set('locale', localeParam)
            this.inventoryViewerParams = queryParams.toString()
        }

        if (!this.inventoryViewerBaseUrl) {
            return ''
        }
        return this.inventoryViewerBaseUrl + '?' + this.inventoryViewerParams
    }

    public static async sendIVEvent (event: IVEvent, origin: IVOrigin) {
        let contentWindow: any
        if (origin === 'modal') {
            contentWindow = (document.getElementById(IVFrameId) as HTMLIFrameElement).contentWindow
        } else if (origin === 'sidebar') {
            // Wait 1 second for iframe to load into html
            await new Promise((res) => setTimeout(res, 1000))
            // tslint:disable-next-line due to no-unnecessary-type-assertion error but cast is required
            contentWindow = (document.querySelector('iframe[title="inventory_viewer_v2"]') as HTMLIFrameElement).contentWindow
        }
        return CrossFrameUtils.sendMessageToOtherFrame({
            frame: contentWindow,
            message : {
                method: event,
            },
        })
    }

    /**
     * Send event to tool iframe
     * @param event - event to send to tool iframe. In this context, opening and closing of the modal
     * @param toolType - type of tool to send event to. In this context, ATBase (tools migrated to react/meridian) or seaward
     *
     * @returns Promise - promise that will receive response, if any
     */
    public static async sendEventToToolIframe (event: IVEvent, toolType: ToolType) {
        let divWrapperAroundIFrame: Element
        if (toolType === 'ATBase') {
            divWrapperAroundIFrame = document.getElementsByClassName(ATBaseToolFrameContainerClass)?.item(0)
        } else if (toolType === 'seaward') {
            divWrapperAroundIFrame = document.getElementsByClassName(SeawardToolFrameContainerClass)?.item(0)
        }

        let iframe: HTMLIFrameElement
        if (divWrapperAroundIFrame) {
            iframe = divWrapperAroundIFrame.querySelector('iframe')
        }

        if (!iframe) {
            return
        }

        return CrossFrameUtils.sendMessageToOtherFrame({
            frame: iframe.contentWindow,
            message: {
                method: event,
            },
        })
    }
}
